export const formatPercentage = (str) => {
  return  str > 1 ? 100 : Math.round(str * 100)
}

export const currentQuarter = '2025Q2';
